<script setup lang="ts">
import {BlockProps, CustomDTOExpression} from "@/utils/presenters/interfaces.ts";
import {computed, onBeforeMount, ref, watch} from "vue";
import CriteriaView from "@/views/CriteriaView.vue";
import CriteriaTreeUtils from "@/utils/common/CriteriaTreeUtils.ts";
import EditViewUtils from "@/utils/editView/EditViewUtils.ts";
import {QTreeNode} from "quasar";
import {NamaNavigateToNextEmit} from "@/utils/common/NamaVueWidget.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NaMaMetaData = namaTypes.NaMaMetaData;
import DTOCriteria = namaTypes.DTOCriteria;

const props = defineProps<BlockProps>();
defineEmits<NamaNavigateToNextEmit>()
const criteriaViewRef = ref<typeof CriteriaView | null>(null);
const metadata = ref<NaMaMetaData | undefined>();
const criteriaFields = ref();
const criteriaOwnerType = computed(() => props.presenter.fetchRecord().forType);
const recordId = computed(() => {
  return props.presenter.fetchRecord().id;
});
const criteriaTree = ref<QTreeNode<CustomDTOExpression>[]>([]);

async function initialize() {
  if (criteriaOwnerType.value) {
    metadata.value = await EditViewUtils.fetchCriteriaMetadata(criteriaOwnerType.value);
    criteriaFields.value = EditViewUtils.createCriteriaFieldsFromMetadata(metadata.value);
    let criteria = NamaCommon.cloneObject(props.presenter.fetchRecord().criteria);
    criteriaTree.value = CriteriaTreeUtils.criteriaToTree(criteria, criteriaFields.value);
  } else {
    criteriaTree.value = [];
  }
}

onBeforeMount(async () => {
  await initialize();
});

watch([() => criteriaOwnerType.value, () => props.presenter.fetchRecord().id, () => props.presenter.fetchRecord().criteria],
  async () => {
    await initialize();
  });

watch(() => criteriaTree.value, (tree) => {
  if (!props.presenter.fetchRecord().criteria)
    props.presenter.fetchRecord().criteria = {};
  props.presenter.fetchRecord().criteria.fromVue = false;
  let crt: DTOCriteria = {};
  CriteriaTreeUtils.updateCriteriaFromTree(crt, JSON.parse(JSON.stringify(tree)), criteriaFields.value);
  let fl = CriteriaTreeUtils.flattenTree(crt.expressions);
  props.presenter.fetchRecord().criteria.expressions = fl.slice(1, fl.length - 1);

}, {deep: true});

</script>

<template>
  <div v-if="metadata && criteriaFields && criteriaTree" class="tw-h-full tw-w-full"
       :key="recordId">
    <q-card class="tw-h-full tw-w-full tw-flex tw-flex-col tw-shadow-none tw-bg-transparent tw-p-0">
      <CriteriaView v-model:criteria-tree="criteriaTree" :owner-entity="criteriaOwnerType" :isFilterEmpty="false" :isWidget="true"
                    :onCriteriaViewEnterDown="()=>{}" :criteria-fields="criteriaFields" ref="criteriaViewRef" :isHasHeight="true"/>
    </q-card>
  </div>
</template>

<style scoped>

</style>
